"use strict"

import { DataView } from '../dataview.js';
import { ModalCourse } from "../modals/modalCourse.js";
import { ModalShowDayAbsences } from "../modals/modalShowDayAbsences.js";
import { ModalShowAbsentItemsOfClass } from "../modals/modalShowAbsentItemsOfClass.js";
import { ModalShowPupilNotes} from "../modals/modalShowPupilNotes.js";
import { ModalShowAbsences } from "../modals/modalShowAbsences.js";
import { ModalShowAbsentItemsOfPupil } from "../modals/modalShowAbsentItemsOfPupil.js";
import { ModalShowAbsenceDetails } from "../modals/modalShowAbsenceDetails.js";
import { ModalShowDayAbsenceDetails } from "../modals/modalShowDayAbsenceDetails.js";

export class Data {

   constructor(app) {
      this.app = app;
      this.dm = app.dm;

      this.tab = document.querySelector('.main-item[tab-name="data"]');
      this.elMain = this.tab.querySelector('.main-content');

      this.tab.querySelectorAll('.data-button').forEach(btn => btn.accordion({
         panelTransition: 'max-height .3s ease-in',
         closeOtherParent: this.tab,
         onOpening: async (elButton, elPanel) => {
            let panel = elButton.dataset.panel;
            await this.loadPanel(panel, elPanel);

            window.requestAnimationFrame(() => {
               elPanel.parentElement.style.maxHeight = elPanel.parentElement.scrollHeight + "px";
            });
         }
      }));

      this.tab.querySelector('.admin .absences-mss').onclick = () => new ModalShowAbsences(this.app, 'pupil'); 
      this.tab.querySelector('.admin .class-register-all').onclick = () => {
         const url = this.app.server+'?action=classreg-get&export=all&format=pdf&auth-token=' + localStorage.getItem('authToken');
         window.open(url, '_blank').focus();
      }
      this.tab.querySelector('.admin .absences-mss-export').onclick = () => this.downloadMssAbsences();
      this.tab.querySelector('.admin .day-absences-export').onclick = () => this.downloadDayAbsences();

   }

   load(loadData) {

      this.user = this.dm.getUserSelf();

      if (this.user.type === 'teacher') {
         this.tab.querySelectorAll('.data-button[user-type="pupil"]').forEach(btn => btn.style.display = 'none');
      }
      else {
         this.tab.querySelectorAll('.data-button[user-type="teacher"]').forEach(btn => btn.style.display = 'none');
      }

      let isFormTeacher = this.dm.getFormTeacherClasses().length !== 0;
      this.tab.querySelector('[data-panel="my-classes"]').style.display = isFormTeacher ? 'block' : 'none';
      this.tab.querySelector('[data-panel="my-classes"] + .accordion-panel').style.display = isFormTeacher ? 'block' : 'none';

      let isTutor = this.dm.getTutoredPupils(this.user.id).length > 0;
      this.tab.querySelector('[data-panel="my-tutor-courses"]').style.display = isTutor ? 'block' : 'none';
      this.tab.querySelector('[data-panel="my-tutor-courses"] + .accordion-panel').style.display = isTutor ? 'block' : 'none';


      let isAdmin = this.user.hasPermission('classreg', 'view-all');
      this.tab.querySelector('[data-panel="admin"]').style.display = isAdmin ? 'block' : 'none';
      this.tab.querySelector('[data-panel="admin"] + .accordion-panel').style.display = isAdmin ? 'block' : 'none';

   }

   async loadPanel(panel, elPanel) {
      if      (panel === 'files') await this.loadFiles(elPanel);
      else if (panel === 'my-courses') await this.loadMyCourses(elPanel);
      else if (panel === 'my-classes') await this.loadMyClasses(elPanel);
      else if (panel === 'my-tutor-courses') await this.loadMyTutorCourses(elPanel);
      else if (panel === 'admin') await this.loadAdmin(elPanel);
      else if (panel === 'pupil-absences') this.loadPupilAbsences(elPanel);
   }

   async loadFiles(elPanel) {

      elPanel.empty();

      let elList = HTMLElement.createFromHTML('<ul class="files"></div>');

      let data = await this.dm.getFiles();

      for (let item of data.data) {
         const elItem = elList.createElement('li', 'file');
         elItem.innerHTML = '<a href="' + this.app.server + '?action=fil-download&url=files%2F' + item.url + '&auth-token=' + localStorage.getItem('authToken') + '" target="_blank">' + item.title + '</a>';
      }

      elPanel.appendChild(elList);


   }

   loadMyCourses(elPanel) {

      let user = this.dm.getUserSelf();
      let myCourses = this.dm.getMyCourses();

      this.listCourses = new DataView(elPanel.querySelector('.dv-courses'));

      var listSettings = {
         columns: [
            {
               title: 'Klasse',
               data: 'classNames',
               sort: { index: 1, dir: 1, value: function(course) {
                  return (course.classNames.search(/^\d\d/) === -1) ? '0' + course.classNames : course.classNames;
               }},
               css: () => { return { 'padding': '.5rem' }; }
            },
            {
               title: 'Fach',
               data: 'short',
               sort: { index: 2, dir: 1 }
            },
            {
               title: 'Lehrer',
               data: (course) => {
                  let teachers = course.teachers.map(teacherId => { return this.dm.getUser(teacherId).short; });
                  return teachers.join(',');
               },
               sort: { index: 3, dir: 1 }
            }
         ],
         showHeader: false,
         onSelected: (course) => {
            if (user.type === 'teacher') {
               //new ModalEditCourse(course.id, this.dm);
               new ModalCourse(app, course);
            }
         }
      };

      this.listCourses.load(myCourses, listSettings);


   }

   loadMyClasses(elPanel) {

      elPanel.empty();
      const classes = this.dm.getFormTeacherClasses();

      for (let cls of classes) {
         let elClass = HTMLElement.createFromHTML(`
            <table class="my-class">
               <tr>
                  <td rowspan="4" class="title">${cls.name}</td>
                  <td><div class="flat-button absences">Fehltage</div></td>
               </tr>
               <tr><td><div class="flat-button absent-homework">Versäumte Hausaufgaben aller Fächer</div></td></tr>
               <tr><td><div class="flat-button absent-material">Vergessene Arbeitsmaterialien aller Fächer</div></td></tr>
               <tr><td><div class="flat-button pupil-notes">Schüler-Anmerkungen</div></td></tr>
            </table>
         `);

         elClass.querySelector('.flat-button.absences').onclick = () => new ModalShowDayAbsences(this.app, cls);
         elClass.querySelector('.flat-button.absent-homework').onclick = () => new ModalShowAbsentItemsOfClass('homework', 'Versäumte Hausaufgaben aller Fächer', this.app, cls);
         elClass.querySelector('.flat-button.absent-material').onclick = () => new ModalShowAbsentItemsOfClass('material', 'Vergessene Arbeitsmaterialien aller Fächer', this.app, cls);
         elClass.querySelector('.flat-button.pupil-notes').onclick = () => new ModalShowPupilNotes(this.app, { class: cls });

         elPanel.append(elClass);
      }


   }

   loadMyTutorCourses(elPanel) {

      elPanel.empty();

      const tutPupilIds = this.dm.getTutoredPupils(this.user.id).map(pupil => pupil.id);

      let el = HTMLElement.createFromHTML(`
         <table class="my-tutor-course">
            <tr><td><div class="flat-button absences">Fehltage</div></td></tr>
         </table>
      `);

      el.querySelector('.flat-button.absences').onclick = () => new ModalShowAbsences(this.app, 'pupil', { tutPupilIds });

      elPanel.append(el);

   }


   loadAdmin() {

   }

   loadPupilAbsences() {

      const user = this.dm.getUserSelf();
      const cls = this.dm.getClass(user.classId);
      if (cls.year < 11) {
         this.tab.querySelector('.panel.pupil-absences .btn-classreg-absences').style.display = 'none';
      }
      else {
         this.tab.querySelector('.panel.pupil-absences .btn-day-absences').style.display = 'none';
      }

      this.tab.querySelector('.btn-absent-homework').onclick = () => {
         let user = this.dm.getUserSelf();
         new ModalShowAbsentItemsOfPupil(this.app, 'homework', "Versäumte Hausaufgaben", user);
      }

      this.tab.querySelector('.btn-absent-material').onclick = () => {
         let user = this.dm.getUserSelf();
         new ModalShowAbsentItemsOfPupil(this.app, 'material', "Vergessene Arbeitsmaterialien", user);
      }

      this.tab.querySelector('.btn-pupil-notes').onclick = () => {
         let user = this.dm.getUserSelf();
         new ModalShowPupilNotes(this.app, { pupil: user });
      }

      this.tab.querySelector('.btn-day-absences').onclick = () => {
         let user = this.dm.getUserSelf();
         this.dm.sinRequest({ action: 'day-absence-get-missed-days', id: user.id }).then(response => {
            new ModalShowDayAbsenceDetails(this.app, user, response.data);
         });
      }

      this.tab.querySelector('.btn-classreg-absences').onclick = () => {
         let user = this.dm.getUserSelf();
         this.dm.sinRequest({ action: 'classreg-absence-get', type: 'pupil', pupilId: user.id }).then(response => {
            new ModalShowAbsenceDetails(this.app, user.id, response.data);
         });
      }

   }

   async downloadMssAbsences() {

      const response = await Promise.all([
         this.app.dm.sinRequest({ action: 'classreg-absence-get', type: 'pupil', classIds: [this.dm.getClassByName('11').id] }),
         this.app.dm.sinRequest({ action: 'classreg-absence-get', type: 'pupil', classIds: [this.dm.getClassByName('12').id] }),
         this.app.dm.sinRequest({ action: 'classreg-absence-get', type: 'pupil', classIds: [this.dm.getClassByName('13').id] }),
      ]);

      const schema = [
         { column: "Nachname", type: String, value: o => o.lastName },
         { column: "Vorname", type: String, value: o => o.firstName },
         { column: "Datum", type: String, value: o => o.date },
         { column: "Kurs", type: String, value: o => o.course },
         { column: "Lehrer", type: String, value: o => o.teacherShort },
         { column: "Anzahl", type: Number, value: o => o.cnt},
         { column: "entsch.", type: String, value: o => o.justified ? '✔' : '✖'},
         { column: "Bemerkung", type: String, value: o => o.note },
      ];

      const absences = response.map(result => {
         return result.data.map(abs => {
            const pupil = this.dm.getPupil(abs.pupilId);
            abs.lastName = pupil.lastName;
            abs.firstName = pupil.firstName;
            abs.teacherShort = this.dm.getUser(abs.teacherId).short;
            return abs;
         });
      });

      await writeXlsxFile(absences, {
         schema: [schema, schema, schema],
         sheets: ['11', '12', '13'],
         fileName: `Fehlstunden MSS (${this.dm.getCurrentYear().name}).xlsx`
      });

   }

   async downloadDayAbsences() {

      const response = await this.app.dm.sinRequest({ action: 'day-absence-get-all' });

      const schema = [
         { column: "Nachname", type: String, value: o => o.lastName },
         { column: "Vorname", type: String, value: o => o.firstName },
         { column: "Datum von", type: String, value: o => o.dateFrom },
         { column: "Datum bis", type: String, value: o => o.dateTo },
         { column: "Typ", type: String, value: o => o.type },
         { column: "Verspätung", type: Number, value: o => o.lateTime },
         { column: "Uhrzeit von", type: String, value: o => o.absentFrom ? `${Math.floor(o.absentFrom/60).toString().padStart(2,'0')}:${(o.absentFrom % 60).toString().padStart(2,'0')} Uhr` : '' },
         { column: "Uhrzeit bis", type: String, value: o => o.absentTo ? `${Math.floor(o.absentTo/60).toString().padStart(2, '0')}:${(o.absentTo % 60).toString().padStart(2, '0')} Uhr` : '' },
         { column: "entsch.", type: String, value: o => o.justified ? '✔' : '✖' },
         { column: "Bemerkung", type: String, value: o => o.note },
         { column: "abgem. von", type: String, value: o => o.creator  + (o.lastModifier === o.creator ? '' : '/' + o.lastModifier)},
         { column: "entsch. von", type: String, value: o => o.justifier }
      ];

      const absences = response.data.map(abs => {
         const pupil = this.dm.getPupil(abs.pupilId);
         abs.lastName = pupil.lastName;
         abs.firstName = pupil.firstName;
         abs.color = abs.justified ? '#000000' : '#ff0000';
         abs.type = { checked: 'abgemeldet', school: 'schulisch', late: 'verspätet', missing: 'vermisst'}[abs.absenceType];
         return abs;
      });

      //console.log(absences);

      await writeXlsxFile(absences, {
         schema,
         fileName: `Fehltage (${this.dm.getCurrentYear().name}).xlsx`
      });

   }
   

};
